import {
  CHECK_IF_PROMO_CONFIGURED_REQUEST,
  CHECK_IF_PROMO_CONFIGURED_SUCCESS,
  CHECK_IF_PROMO_CONFIGURED_FAILURE
} from '@/actions/promoConfigs/actionTypes';

export const initialState = {
  isLoading: false,
  isPromoConfigured: false
};

const promoConfigReducers = (state = initialState, action) => {
  switch (action.type) {
    case CHECK_IF_PROMO_CONFIGURED_REQUEST:
      return {
        ...state,
        isLoading: true
      };

    case CHECK_IF_PROMO_CONFIGURED_SUCCESS:
      return {
        ...state,
        isLoading: false,
        isPromoConfigured: action.data.promoConfigPresent
      };

    case CHECK_IF_PROMO_CONFIGURED_FAILURE:
      return {
        ...state,
        isLoading: false
      };

    default:
      return state;
  }
};

export default promoConfigReducers;
